import type { Product } from "src/api/client-api/products/useGetOneProduct";

type ProductPackaging = NonNullable<Product["productPackagings"]>[number];

export const getPackagingDisplayName = (productPackaging: ProductPackaging): string =>
    productPackaging.packaging?.name || productPackaging.packagingReferenceName || "-";

export const getPackagingChipLabel = (productPackaging: ProductPackaging): string => {
    const name = getPackagingDisplayName(productPackaging);
    const quantity = productPackaging.quantity;

    if (quantity === null || quantity === undefined) {
        return name;
    }

    return `${name} (${quantity})`;
};

export const formatWeightGrams = (weight: number | null | undefined): string | null => {
    if (weight === null || weight === undefined) {
        return null;
    }

    return `${weight} g`;
};
